import { toast } from 'react-toastify';
import { MSG } from '../constants/toastMessages';

// File links are signed and expire (BE utils/signedUrl.js: 12–24 h; shares up to
// 7 days). A page left open longer gets media load errors. When the link that failed
// has EXPIRED, reload the page once so it fetches fresh links, and say why. An
// ordinary error (link still valid) is left alone, and a second expiry within a minute
// does not reload again, so this can never loop.
const RELOAD_KEY = 'expiredLinksReloadAt';
const MIN_GAP_MS = 60 * 1000;

export function signedLinkExpired(src, now = Date.now()) {
  if (typeof src !== 'string' || !src.includes('X-Goog-Expires=')) return false;
  let params;
  try { params = new URL(src).searchParams; } catch (_) { return false; }
  const date = params.get('X-Goog-Date') || '';
  const m = date.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/);
  const seconds = Number(params.get('X-Goog-Expires'));
  if (!m || !Number.isFinite(seconds)) return false;
  const start = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]);
  return now >= start + seconds * 1000;
}

export function reloadIfLinksExpired(src, { now = Date.now(), reload = () => window.location.reload() } = {}) {
  if (!signedLinkExpired(src, now)) return false;
  let last = 0;
  try { last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0; } catch (_) { /* storage blocked */ }
  if (now - last < MIN_GAP_MS) return false;
  try { sessionStorage.setItem(RELOAD_KEY, String(now)); } catch (_) { /* storage blocked */ }
  toast.info(MSG.linksExpired);
  setTimeout(reload, 1500);
  return true;
}
